import Button from "../Button/Button";
import {FC, useState} from "react";
import {bookingFlows, windowRepairImage} from "../../../constants/global";
import {getNextStep, getPrevStep, isStepFulfilled, isStepOptionsFulfilled, storeBooking} from "../../../lib/booking";
import {useNavigate} from "react-router-dom";
import findMenuItem from "../../../lib/find-menu-item";
import {postBooking} from "../../../wordpress/operations/post-booking";
import {updateBooking} from "../../../wordpress/operations/post-booking-update";
import {postImage} from "../../../wordpress/operations/post-image";

interface Props {
    booking: Booking,
    setBooking: Function,
    content: Content
}

const NavNextPrev: FC<Props> = ({booking, setBooking, content}) => {
    const navigate = useNavigate();
    const bookingFlow = bookingFlows[booking.booking_flow]
    const activeStep = bookingFlow.step
    const next = getNextStep(bookingFlow.menu, activeStep)
    const prev = getPrevStep(bookingFlow.menu, activeStep)
    const stepFullFilled = isStepFulfilled(activeStep, booking)
    const useBackButton = false

    const nextStep = () => {
        booking.modal = 0;
        storeBooking(booking, setBooking)

        if (!isStepFulfilled(activeStep, booking, setBooking, true)) {
            return
        }

        if (activeStep === 'hjulskifte' && booking.service.step === 'closed') {
            navigate('/datum')
            return
        }

        if (activeStep === 'hjulskifte' && booking.service.step === 'open') {
            navigate('/tillval')
            return
        }

        // Hjulskifte date and time update
        if (activeStep === 'date' && booking.hjulskifte_update) {
            if(!isStepOptionsFulfilled(booking, true, setBooking)) {
                return
            }

            booking.order_loading = true
            storeBooking(booking, setBooking)

            updateBooking(booking).then((val) => {
                booking.order_loading = false
                storeBooking(booking, setBooking)
                 if (val.status === 'success') {
                    if(val.redirect) {
                        window.location.replace(val.redirect);
                    }else{
                        navigate('/tack-for-din-bokning') // Navigate order summary
                    }
                    return
                } else {
                    // Error
                    booking.order_loading = false
                    storeBooking(booking, setBooking)
                }
            })
            return
        }


        if (activeStep === 'contact') {
            if (booking.order_loading) {
                return
            }

            booking.order_loading = true
            storeBooking(booking, setBooking)

            postBooking(booking).then((val) => {
                booking.order_loading = false

                if (val.status === 'success') {
                    if (windowRepairImage.image) {
                        postImage(booking).then((val) => {
                            booking.order_key = val.order_key // For order summary
                            storeBooking(booking, setBooking)
                            navigate('/tack-for-din-bokning') // Navigate order summary
                        })
                    } else {
                        booking.order_key = val.order_key // For order summary
                        booking.hjulskifte_key = null // Reset customer details
                        storeBooking(booking, setBooking)
                        navigate('/tack-for-din-bokning') // Navigate order summary
                    }
                    return
                } else {
                    // Error
                    booking.order_loading = false
                    storeBooking(booking, setBooking)
                }
            })
            return
        }

        const item = findMenuItem(next, content)
        booking.page = item.slug
        storeBooking(booking, setBooking)
        navigate('/' + item.slug)
    }

    const prevStep = () => {
        const item = findMenuItem(prev, content)
        navigate('/' + item.slug)
    }

    let buttonText = 'Fortsätt'
    switch (activeStep) {
        case 'contact':
            buttonText = 'Slutför'
            break;
    }

    return (
        <div className="nav-next-prev">
            <Button id="btn-next" className={'grow btn-footer-next btn-booking-next btn btn-center btn--skyblue'} loading={booking.order_loading} title={buttonText} action={nextStep} active={stepFullFilled}/>
            {prev && useBackButton && (
                <Button id="btn-prev" className={'grow btn-booking-prev btn btn-center btn--skyblue'} loading={false} title={'Bakåt'} action={prevStep} active={true}/>
            )}
        </div>
    );
};
export default NavNextPrev
